<template>
  <div>
    <FormFieldsRow
      v-for="(component, index) in components"
      :key="'component-row' + index"
      :index="index"
      :isEditing="!disabled"
      class="mb-4"
    >
      <FormComponent
        :value="component"
        :editable="!disabled"
        :config="config"
        :formValue="formValue"
        :iteration="iteration"
        :index="index"
        :nestedMode="nestedMode"
        class="p-3"
        @input="updateItem(index, $event, true)"
        @delete="deleteItem(index)"
      />
    </FormFieldsRow>
    <div
      v-if="!components || !components.length"
      class="p-3 mb-2 text-muted bg-light rounded-5 text-center border"
    >No Components Added</div>
    <AppButton
      v-if="!disabled"
      @click.stop="addItem"
    >
      <AppIcon name="add" />Add Component
    </AppButton>
  </div>
</template>
<script>
import FormMixin from '@/components/Forms/FormMixin'
import FormFieldsRow from '@/components/Forms/FormFieldsRow'
import FormComponent from '@/components/Forms/FormComponent'
import useFormListWrapper from './composables/useFormListWrapper'

export default {
  mixins: [ FormMixin ],
  components: { FormFieldsRow, FormComponent },
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { root, emit }) {
    function createEmptyItem () {
      return {
        id: root.generateToken(5),
        code: '',
        name: '',
        creditHours: 0,
        contactHours: 0,
        workloadHours: 0,
        defaultSectionSize: 0,
        finalExamType: '',
        lmsFileType: '',
        instructionMode: '',
        preferredRoomFeatures: [],
        attendanceType: '',
      }
    }

    const {
      items,
      updateItem,
      addItem,
      deleteItem,
    } = useFormListWrapper({ props, emit, createEmptyItem })

    return {
      components: items,
      updateItem,
      addItem,
      deleteItem,
    }
  },
}
</script>
